import HikTravelTimeModal from './hik-travel-time-modal.vue'
export default HikTravelTimeModal
